import Phaser from 'phaser'
import Config from '../launch/config'
import Ship from '../ship/ship'
import Satellite from '../satellite/satellite'
import ArcTimer from '../arc-timer/arc-timer'
import {saveGame} from '../launch/store'
import {isLaunchDev} from '../launch/utils'
import {gameOverCheck} from '../game-over/utils'
import {_addToEventLog} from '../app/app'
import {setShipDestination} from '../ship/utils'

const dispatchShips = ({difficulty, ships}) => {
    const idleShips = ships.filter((key) => {
        const ship = Config.ships[key]
        return ship.type !== 'satellite' && !ship.moving && !ship.fighting
    })
    const targetPlanets = Object.keys(Config.entities).filter((key) => {
        const entity = Config.entities[key]
        return entity.type === 'planet'
    })

    const randomPlanetKey =
        targetPlanets[Phaser.Math.Between(0, targetPlanets.length - 1)]

    const targetPlanet = Config.entities[randomPlanetKey]

    idleShips.forEach((shipKey, index) => {
        const ship = Config.ships[shipKey]

        // Allow ship to follow other ships
        delete ship.following

        // Easy - Send 1 ship at a time
        let allowedShipIndex = 0

        // Normal - Send 1 - 2 ships at a time
        if (Config.difficulty === 'difficulty2') {
            allowedShipIndex = Phaser.Math.Between(0, 1)
        }

        // Hard - Send 1 - 3 ships at a time
        if (Config.difficulty === 'difficulty3') {
            allowedShipIndex = Phaser.Math.Between(0, 2)
        }

        if (index > allowedShipIndex) {
            return
        }

        const entity = ship.orbitingEntity

        // Conquer/Colonize planet
        if (entity && entity.faction !== ship.faction) {
            const entityKey = ship.orbitingEntity.id
            const entity = Config.entities[entityKey]
            const opposingShipsInOrbit = Object.keys(entity.orbitingShips).find(
                (key) => {
                    return (
                        entity.orbitingShips[key].faction ===
                        Config.userFactionName
                    )
                }
            )

            if (
                Config.isGameOver ||
                opposingShipsInOrbit ||
                entity.isColonizing
            ) {
                return
            }

            entity.isColonizing = true

            let color = Config.colorRed

            if (Config.enemyFactions.length) {
                const colorMap = {
                    0: 'colorRed',
                    1: 'colorOrange',
                    2: 'colorBlue',
                    3: 'colorGreen',
                }
                color = Config[colorMap[ship.faction.at(-1)]] || 'flagRed'
            }

            const arc = new ArcTimer({
                color,
                duration: difficulty.planetColonizeTime,
                radius: entity.diameter + 2,
                reverse: true,
                x: entity.x,
                y: entity.y,
                hidden: !entity.discovered,
            })

            arc.promise
                .then(() => {
                    if (entity.faction === Config.userFactionName) {
                        Config.gameStats.planetsLost += 1
                        Config.gameStats.score -=
                            difficulty.planetColonizePoints

                        _addToEventLog({
                            html: `The planet <span style="color: #${Config.colorRed}">${entity.name}</span> has been lost`,
                            coords: {x: entity.x, y: entity.y},
                        })
                    }

                    entity.faction = ship.faction
                    entity.colonized = true
                    entity.isColonizing = false
                    entity.isHomePlanet = false
                    entity.isMiningResources = false

                    saveGame('enemyMove - colonize')
                    gameOverCheck('enemyMove - colonize')
                })
                .catch((e) => {})

            return
        }

        targetPlanet &&
            setShipDestination({
                ship,
                x: targetPlanet.x,
                y: targetPlanet.y,
            })
    })
}

const spawnShips = ({difficulty, faction, ships, satellites}) => {
    if (Config.isGameOver) {
        return
    }

    const enemyPlanetKeys = Object.keys(Config.entities).filter((key) => {
        const entity = Config.entities[key]
        return entity.type === 'planet' && entity.faction === faction
    })

    const randomEntityKey =
        enemyPlanetKeys[Phaser.Math.Between(0, enemyPlanetKeys.length - 1)]

    const orbitingEntity = Config.entities[randomEntityKey]

    if (orbitingEntity) {
        const shipConfig = {
            faction,
            orbitingEntity,
            x: orbitingEntity.x,
            y: orbitingEntity.y,
        }

        if (
            Config.chance.d4() === 1 &&
            ships.length < difficulty.enemyShipMax
        ) {
            new Ship(shipConfig)
            saveGame('enemyMove - build ship')
        }

        if (
            Config.chance.d20() === 1 &&
            satellites.length < difficulty.enemySatelliteMax
        ) {
            new Satellite(shipConfig)
            saveGame('enemyMove - build satellite')
        }
    }
}

export const enemyMove = () => {
    if (isLaunchDev) {
        return
    }

    const difficulty = Config.difficultyLevels[Config.difficulty]

    if (Config.isDemo && Config.enemyFactions.length) {
        Config.enemyFactions.forEach((faction) => {
            const ships = Object.keys(Config.ships).filter((key) => {
                const ship = Config.ships[key]
                return ship.faction === faction
            })
            const satellites = ships.filter((key) => {
                const ship = Config.ships[key]
                return ship.type === 'satellite'
            })

            dispatchShips({difficulty, ships})
            spawnShips({difficulty, faction, ships, satellites})
        })
    } else {
        const ships = Object.keys(Config.ships).filter((key) => {
            const ship = Config.ships[key]
            return ship.faction === Config.enemyFactionName
        })
        const satellites = ships.filter((key) => {
            const ship = Config.ships[key]
            return ship.type === 'satellite'
        })

        dispatchShips({difficulty, ships})
        spawnShips({
            difficulty,
            faction: Config.enemyFactionName,
            ships,
            satellites,
        })
    }
}
